import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import moment from 'moment';
import { RewardCenterTabs } from './Constants';
import CdnPath from '../../utils/cdnPath';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import store from '../../state/store';
import { setRewardCenterCurrTab, setRewardCenterPrevTab } from '../../state/actions/rewardCenter';
import audio from '../../utils/audio';
import { postRewardCenter } from '../../state/query/rewardCenter';
import ERROR_CODE from '../../utils/errorCodes';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});
var DISABLED_FILTER = -1;
var DIALOG_BACKGROUND = 'defaultrcnewsitem.jpg';
var DIALOG_TITLE_ASSET = 'title.png';

var RewardCenter = /*#__PURE__*/function (_Component) {
  _inherits(RewardCenter, _Component);

  var _super = _createSuper(RewardCenter);

  function RewardCenter(props) {
    var _this;

    _classCallCheck(this, RewardCenter);

    _this = _super.call(this, props);

    _this._onPropertyChange = function (event) {
      audio.onClick();
      var newProperty = event.target.value;

      _this.setState({
        activeProperty: parseInt(newProperty, 10)
      });
    };

    _this.setTabs = function () {
      audio.onClick();
      store.dispatch(setRewardCenterCurrTab(RewardCenterTabs.OFFERS));
      store.dispatch(setRewardCenterPrevTab(RewardCenterTabs.HOME));
    };

    _this._onFilterChange = function (event) {
      audio.onClick();
      var newFilter = event.target.value;

      _this.setState({
        activeFilter: parseInt(newFilter, 10),
        scrollBarHeight: 10
      });

      _this.setTabs();
    };

    _this._onScroll = function () {
      _this.setState({
        scrollBarHeight: 10
      });
    };

    _this._initializeRewards = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, initializeRewardCenter, setActiveTab, preselectedTab, _initRewardRequest$pr, _yield$store$dispatch, initRewardRequest, displayRewardProfileScreen;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, initializeRewardCenter = _this$props.initializeRewardCenter, setActiveTab = _this$props.setActiveTab;
              preselectedTab = _this.state.preselectedTab;
              _context.prev = 2;
              _context.next = 5;
              return store.dispatch(postRewardCenter.initiate()).unwrap();

            case 5:
              _yield$store$dispatch = _context.sent;
              initRewardRequest = _yield$store$dispatch[0];
              displayRewardProfileScreen = ((_initRewardRequest$pr = initRewardRequest.profile) === null || _initRewardRequest$pr === void 0 ? void 0 : _initRewardRequest$pr.displayRewardProfileScreen) === 'yes';
              initializeRewardCenter({
                api: initRewardRequest,
                ux: {
                  hasData: true
                }
              });

              if (displayRewardProfileScreen && preselectedTab && setActiveTab) {
                setActiveTab(preselectedTab);

                _this.setState({
                  preselectedTab: null
                });

                QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_RC_TAB, undefined));
              }

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.INIT_REWARD_CENTER_REQUEST_ERROR
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    _this._onTabChange = function (event) {
      audio.onClick();
      var newTab = event.target.dataset.tabName;
      var _this$props2 = _this.props,
          rewardCenter = _this$props2.rewardCenter,
          setActiveTab = _this$props2.setActiveTab;

      switch (newTab) {
        case RewardCenterTabs.Home:
          {
            // handle query string
            newTab = RewardCenterTabs.OFFERS;
            break;
          }

        case RewardCenterTabs.PROFILE:
          {
            break;
          }

        case RewardCenterTabs.OFFERS:
          {
            // handle query string
            break;
          }

        case RewardCenterTabs.HISTORY:
          {
            // handle query string
            break;
          }

        case RewardCenterTabs.BACK:
          {
            if (rewardCenter.ux.activeTab === RewardCenterTabs.OFFERS || rewardCenter.ux.activeTab === RewardCenterTabs.PROFILE) {
              newTab = RewardCenterTabs.HOME;
            } else if (rewardCenter.ux.activeTab === RewardCenterTabs.OFFER) {
              newTab = RewardCenterTabs.OFFERS;
            } else if (rewardCenter.ux.activeTab === RewardCenterTabs.HISTORY_DETAIL) {
              newTab = RewardCenterTabs.HISTORY;
            }

            break;
          }

        default:
          console.error('Invalid tab.');
      }

      setActiveTab(newTab);
    };

    _this._dismissModal = function () {
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
    };

    _this.formatLoyaltyExpiry = function (loyaltyExpiryDate) {
      var expiryDate = moment(loyaltyExpiryDate).format('DD MMM YYYY');
      return expiryDate;
    };

    _this.state = {
      activeProperty: DISABLED_FILTER,
      activeFilter: DISABLED_FILTER,
      scrollBarHeight: 10,
      preselectedTab: null
    };
    _this.state.activeFilter = QueryParamProxy.findParam(RouteParamConstants.PARAM_RC_CATEGORY, DISABLED_FILTER);
    _this.state.preselectedTab = QueryParamProxy.findParam(RouteParamConstants.PARAM_RC_TAB, null);
    return _this;
  }

  _createClass(RewardCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onboardingsSeen = this.props.onboardingsSeen;

      if (onboardingsSeen.includes(ONBOARDING_FLOWS.REWARD_CENTER)) {
        var trigger = Logger.getActionTrigger();
        var eventPayload = {
          trigger: trigger
        };
        Logger.sendEvent(EVENT_TYPES.REWARD_CENTER_OPENED, eventPayload);
      }

      this._initializeRewards();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_RC_CATEGORY, undefined));
      var clearData = this.props.clearData;
      clearData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          render = _this$props3.render,
          rewardCenter = _this$props3.rewardCenter,
          loyalty = _this$props3.loyalty,
          rewardCenterBaseUrl = _this$props3.rewardCenterBaseUrl,
          propertyId = _this$props3.propertyId,
          isVipRoomUnlocked = _this$props3.isVipRoomUnlocked,
          userProperty = _this$props3.userProperty,
          enableOrderCard = _this$props3.enableOrderCard,
          showLinkLoyaltyCardSetting = _this$props3.showLinkLoyaltyCardSetting;
      var _this$state = this.state,
          activeProperty = _this$state.activeProperty,
          activeFilter = _this$state.activeFilter,
          scrollBarHeight = _this$state.scrollBarHeight;
      return render(_objectSpread(_objectSpread({}, rewardCenter), {}, {
        rewardCenterBaseUrl: rewardCenterBaseUrl,
        propertyId: propertyId,
        onTabChange: this._onTabChange,
        dismissModal: this._dismissModal,
        loyalty: format(loyalty.value),
        dialogBackground: "".concat(CdnPath.REWARD_CENTER_NEWS).concat(DIALOG_BACKGROUND),
        dialogTitleAsset: "".concat(CdnPath.REWARD_CENTER_OFFERS_UI).concat(DIALOG_TITLE_ASSET),
        onPropertyChange: this._onPropertyChange,
        onFilterChange: this._onFilterChange,
        onScroll: this._onScroll,
        activeProperty: activeProperty,
        activeFilter: activeFilter,
        isVipRoomUnlocked: isVipRoomUnlocked,
        userProperty: userProperty,
        enableOrderCard: enableOrderCard,
        showLinkLoyaltyCardSetting: showLinkLoyaltyCardSetting,
        scrollBarHeight: scrollBarHeight,
        shouldShowBackNavigation: rewardCenter.ux.activeTab !== RewardCenterTabs.HOME && rewardCenter.ux.activeTab !== RewardCenterTabs.HISTORY && rewardCenter.ux.activeTab !== RewardCenterTabs.PROFILE
      }));
    }
  }]);

  return RewardCenter;
}(Component);

export { RewardCenter as default };